export enum DynamicFieldDefinitionOptionType {
    Select = 'Select',
    Lookup = 'Lookup',
}
